import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import React from 'react';
import { SignupContext } from './signup-context';
export default function useAddressFields() {
    const context = React.useContext(SignupContext);
    // Throw if this hook is used from outside the signup form container (which
    // contains the context provider)
    throwErrorInDev(typeof context === 'undefined', 'useAddressFields can only be used from inside `SignupFormContainer`');
    const { billingAddressFields, countries, setCountry } = context;
    // Change the selected country by country code
    // This will change the fields and validations based on that country's settings
    const setCountryByCode = React.useCallback((countryCode) => {
        const country = countries.find(c => c.code === countryCode);
        if (!country)
            return;
        setCountry(country);
    }, [countries, setCountry]);
    // Filter out the country field from the billing address fields, as it is handled separately
    // See: Countries.tsx
    const fields = billingAddressFields
        .filter(f => f.name !== 'country')
        .map(field => {
        return Object.assign(Object.assign({}, field), { inputProps: {
                key: field.id,
                type: field.type,
                name: field.name,
                label: field.label,
                required: field.required
            } });
    });
    return { fields, countries, setCountryByCode };
}
//# sourceMappingURL=useAddressFields.js.map